export default {"src":"/_next/static/media/icon-7.a1efed71.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};